import { extractNestJsErrorMessage } from '../../../shared/api/rtk-query';
import { CashFlowQuery, cashFlowApi } from './cash-flow.api';

export const useCashFlowList = ({ year, month, managerId, bankAccountId, cashflowId }: CashFlowQuery) => {
  const { data, isLoading, error } = cashFlowApi.useGetCashFlowQuery(
    { year, month, managerId, bankAccountId, cashflowId },
    { refetchOnMountOrArgChange: 60 }
  );
  return {
    collection: data ? data : [],
    error: extractNestJsErrorMessage(error),
    isLoading: isLoading
  };
};
